import React from 'react'
import Icon from 'components/shared/Icon'

export default ({ title, value, options }) => (
  <div className='flex flex-column mt6 f6'>
    <div className='black bb b--black mb2'>{title}</div>
    {options.map(({ label, value: optionValue, url }) => (
      <a
        className='black db f6 ph0 no-underline flex justify-start items-center'
        href={url}
        key={label}
      >
        <Icon
          className='w6 mr4'
          name={value === optionValue
            ? 'icon-checkbox-marked'
            : 'icon-checkbox-blank-thin-outline'}
        />
        {label}
      </a>
    ))}
  </div>
)
